import { useIntl } from "react-intl";

import { getCategoryIcon } from "@/features/hotels/components/hotel/facilityIcons";
import {
  getLocalizedCategoryLabel,
  getLocalizedFacilityLabel,
  type FacilityGroup,
} from "@/features/hotels/utils/facilities/buildHotelFacilitiesDisplayModel";

type Props = {
  facilityGroups: FacilityGroup[];
};

export const HotelFacilityList = ({ facilityGroups }: Props) => {
  const intl = useIntl();

  if (facilityGroups.length === 0) {
    return null;
  }

  return (
    <ul className="flex list-none flex-col gap-5">
      {facilityGroups.map((group) => {
        const CategoryIcon = getCategoryIcon(group.key);

        return (
          <li key={group.key} className="flex flex-col gap-3">
            <div className="flex items-center gap-1">
              <CategoryIcon className="h-5 w-5 text-text-primary" />
              <h4 className="font-semibold text-text-primary">
                {getLocalizedCategoryLabel(intl, group.key, group.label)}
              </h4>
            </div>

            <ul className="flex flex-col gap-2 ps-2.5">
              {group.items.map((facility) => (
                <li
                  key={facility.key}
                  className="flex items-center gap-2 text-sm text-text-secondary"
                >
                  <span aria-hidden="true" className="select-none">
                    •
                  </span>
                  <span>
                    {getLocalizedFacilityLabel(
                      intl,
                      facility.localizationKey,
                      facility.label,
                      facility.value !== undefined
                        ? { count: facility.value }
                        : undefined,
                    )}
                  </span>
                </li>
              ))}
            </ul>
          </li>
        );
      })}
    </ul>
  );
};
